<div class="career-page-container">
  <app-navbar></app-navbar>
  <div class="header d-flexbox">
    <div class="header-content d-flexbox col">
      <div class="btn btn-hover bg-secondary-color">Become POS Merchant</div>
      <div class="big-caption text-default-color">
        Become a POS merchant and have access to multiple POS devices for
        different locations
      </div>
      <p style="text-align: center; width: 90%;">
        We look forward to working with you to meet your growth goals!
      </p>
    </div>
  </div>

  <div class="container d-flexbox">
    <form
      [formGroup]="merchantForm"
      (ngSubmit)="registerMerchant()"
      class="form d-flexbox col justify-content-left align-items-top"
    >
      <div class="d-flexbox row justify-content-between flex-wrap">
        <div
          class="d-flexbox col justify-content-left align-items-top input-grouping"
        >
          <label for="firstName" class="caption-primary-color"
            >First name <span class="danger"> *</span></label
          >
          <input
            type="text"
            formControlName="firstName"
            placeholder="Ex. Jane"
          />
        </div>
        <div
          class="d-flexbox col justify-content-left align-items-top input-grouping"
        >
          <label for="lastName" class="caption-primary-color">Last name <span class="danger"> *</span></label>
          <input
            type="text"
            formControlName="lastName"
            placeholder="Ex. Tailor"
          />
        </div>
      </div>

      <div class="d-flexbox row justify-content-between flex-wrap">
        <div
          class="d-flexbox col justify-content-left align-items-top input-grouping"
        >
          <label for="email" class="caption-primary-color">Email <span class="danger"> *</span></label>
          <input
            type="email"
            formControlName="email"
            placeholder="example@mail.com"
          />
        </div>
        <div
          class="d-flexbox col justify-content-left align-items-top input-grouping"
        >
          <label for="phoneNumber" class="caption-primary-color"
            >Phone number <span class="danger"> *</span></label
          >
          <input
            type="text"
            formControlName="mobile"
            placeholder="0801 001 0001"
          />
        </div>
      </div>

      <label for="businessName" class="caption-primary-color"
        >Business name <span class="danger"> *</span></label
      >
      <input
        type="text"
        formControlName="businessName"
        placeholder="Ex. Marcus & Sons"
      />

      <label for="businessWebsite" class="caption-primary-color"
        >Business Website</label
      >
      <input
        type="text"
        formControlName="businessWebsite"
        placeholder="Ex. www.domain.com"
      />

      <label for="businessSize" class="caption-primary-color"
        >Business Size</label
      >
      <select formControlName="businessSize">
        <option value="5">0-5</option>
        <option value="10">6-10</option>
        <option value="20">11-20</option>
        <option value="50">21-50</option>
        <option value="100">51-100</option>
        <option value="1000">101-1000</option>
        <option value="10000">1001-10000</option>
      </select>
      <label for="businessSize" class="caption-primary-color"
        >Business's Primary Product</label
      >
      <input
        type="text"
        formControlName="businessPrimaryProduct"
        placeholder="School, Finance, etc"
      />

      <label for="businessSize" class="caption-primary-color">Country <span class="danger"> *</span></label>
      <select formControlName="country" id="businessSize">
        <option value="Nigeria" selected="selected">Nigeria</option>
        <option value="{{ country?.name }}" *ngFor="let country of countries">
          {{ country?.name }}
        </option>
      </select>

      <label for="businessSize" class="caption-primary-color"
        >Monthly Income Generated</label
      >
      <select formControlName="monthlyPaymentSize" id="businessSize">
        <option value="5000">&#8358;0 - &#8358;5,000</option>
        <option value="10000">&#8358;6,000 - &#8358;10,000</option>
        <option value="20000">&#8358;11,000 - &#8358;20,000</option>
        <option value="50000">&#8358;21,000 - &#8358;50,000</option>
        <option value="100000">&#8358;51,000 - &#8358;100,000</option>
        <option value="1000000">&#8358;101,000 - 1000,000</option>
        <option value="10000000">&#8358;1,001,000 - &#8358;10,000,000</option>
      </select>

      <label for="noPosReq" class="caption-primary-color">No of POS required</label>
      <input type="number" formControlName="noPosReq" placeholder="1" min="1" />

      <label for="tellUsMore">Tell us more</label>
      <textarea
        formControlName="more"
        cols="30"
        rows="10"
        placeholder="Please tell us about your business"
      ></textarea>

      <div
        class="d-flexbox row justify-content-left align-items-left"
        style="cursor: pointer"
      >
        <input type="radio" name="update" [checked]="broadcastMsg" (click)="uncheckBroadcastMsg()" />
        <label for="update" class="width: 100%"
          >Send me updates and announcements about HuiosPay</label
        >
      </div>
      
      <div style="margin: 15px 0px">
        <input type="radio" name="update" [checked]="privacyPolicy" (click)="uncheckPrivacyPolicy()" />
        Learn more about our
        <a href="#" class="caption-primary-color">Privacy Policy</a>
      </div>
      <div class="btn fill" (click)="registerMerchant()">Apply</div>
    </form>
  </div>

  <!-- Community section-->
  <app-community-section></app-community-section>
  <!--End Community section-->

  <!-- footer -->
  <app-footer></app-footer>
  <!-- end of footer -->

  <app-back-to-top
    [acceleration]="2"
    [animate]="true"
    [scrollDistance]="50"
    [speed]="50"
  >
  </app-back-to-top>
</div>
